<style rel="stylesheet/scss" lang="scss" scoped="scoped">
  .newsBox {
    width: 100%;
    height: 100%;
  }
  .newsContent {
    width: 1100px;
    margin: 120px auto 60px;
    .newsleft {
      padding-left: 30px;
      .titleimg {
        height: 51px;
        margin-bottom: 26px;
      }
      .title {
        font-size: 42px;
        padding-bottom: 30px;
        border-bottom: 1px solid #1b90ef;
      }
    }
    .newsContainer {
      width: 100%;
      margin-left: 60px;
      .contentTtitle {
        margin: 20px 0;
      }
      .contentBox {
        padding-bottom: 10px;
        border-bottom: 1px solid #fff;
      }
    }
  }

  .leftheader {
    width: 100%;
    color: #666;
    >ul {
      width: 100%;
      >li {
        width: 100%;
        cursor: pointer; // float: left;
        text-align: center;
        line-height: 60px;
        color: #000;
        letter-spacing: 3px;
        font-size: 16px;
        .itemCemter {
          display: flex;
          align-items: center;
          .greyline {
            background: #000;
            display: inline-block;
            height: 1px;
            width: 6px;
            margin: 0 40px;
          }
          .activeline {
            background: #1b90ef;
            display: inline-block;
            height: 1px;
            width: 6px;
            margin: 0 40px;
          }
        }
        &:hover {
          color: #1b90ef;
        }
        >ul {
          width: 100%;
          background: #fff;
          text-align: left;
          margin-left: 85px;
          color: #000;
          li {
            &:hover {
              color: #1b90ef;
            }
          }
          .activesub {
            color: #1b90ef;
          }
        }
      }
      .active {
        color: #1b90ef;
      }
    }
  }
</style>
<template>
  <div class="newsBox">

    <Head :selectindex="selectindex"></Head>
    <!-- <header-content @prductListen="scrollHeight"></header-content> -->
    <div class="newsContent flex">
      <div class="newsleft">
        <img class="titleimg" src='../assets/images/contract.png' />
        <div class="title">联系我们</div>
        <div class="leftheader">
          <ul>
            <li :class="[{active:item.show}]" @click="changeli(index,item)" v-for="(item,index) in headerData" :key="index">
              <div class="itemCemter"> <span :class="item.show?'activeline':'greyline'"></span>{{item.name}}</div>
              <ul v-show="item.show">
                <li v-for="(a,inde) in item.list" :class="subactive==inde?'activesub':''" v-on:click.stop="doThis(a,inde)" :key="inde">{{a}}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="newsContainer">
        <div :class="'tableBox'+item.id" v-for="item in contentdata" :key="item.id">
          <div class="contentTtitle font28">{{item.name}}</div>
          <div class="contentBox" v-html="item.content"></div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Head from '../components/headercontent'
  import Foot from '../components/footercontent'
  import Service from '../common/service'
  export default {
    name: "productserver",
    data() {
      return {
        selectindex: 4,
        title: '经营资质',
        subactive: 0,
        headerData: [],
        content: '',
        contentdata: []
      }
    },
    created() {
      // $('.navbar').removeClass('fixed-topone');
      $('.navbar').addClass('fixed-top');
      document.getElementsByTagName("title")[0].innerHTML = "联系我们";
      this.information(2);
    },
    mounted() {
      $('html , body').animate({
        scrollTop: 0
      }, 'slow');
    },
    methods: {
      information(id) {
        Service.information().getinformation({}, id).then(response => {
          var data = response.data;
          this.contentdata = data;
          for(let item of data) {
            var obj = {
              name: item.name,
              show: false,
              id: item.id,
              showContent: true
            }
            this.headerData.push(obj)
          }
          this.title = this.headerData[0].name;
          this.headerData[0].show = true;
          this.content = this.headerData[0].content;
        }, err => {
          console.log(err);
        });
      },
      changeli(ind, item) {
        // 先循环数据中的show将其全部置为false,此时模板里的v-if判断生效关闭全部二级菜单,并移除样式
        this.headerData.forEach(i => {
          // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么headerData[i]等于false
          if(i.show !== this.headerData[ind].show) {
            i.show = false;
          };
        });
        // 取反(true或false)
        item.show = !item.show;
        if(this.title == item.name) {
          item.show = true;
        }
        this.title = item.name;
        this.scrollHeight('.tableBox' + item.id)
      },
      doThis(name, index) {
        this.subactive = index;
        this.title = name;
      },
      handleFun() {
        // 页面滚动距顶部距离
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        var scroll = scrollTop - this.i;
        this.i = scrollTop;
        var height = $('.navbar').height()
        if($(window).scrollTop() >= height) {
          $('.navbar').css({
            'margin-top': '-100px'
          }).addClass('fixed-top');
        } else {
          if(scroll < 0) { //向上滚动
            $('.navbar').css({
              'margin-top': '0px'
            }).removeClass('fixed-top')
          }
        }
      },
      scrollHeight(data) {
        var height = $(data).offset().top;
        $('html,body').animate({
          scrollTop: height
        }, 500);
      }
    },
    components: {
      Head,
      Foot
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleFun, true)
    },
  }
</script>


// WEBPACK FOOTER //
// src/views/linkus.vue